module.exports = __webpack_public_path__ + "img/slider.84707eca.jpg";